import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import './tick-button.scss';

class TickButton extends PureComponent {
  render() {
    const {
      toggleCorrectAnswer,
      markedCorrect,
      loading
    } = this.props;

    return (
      <div className={classNames("tick-button", {
        "tick-button--active": markedCorrect
      })}>
        <div className="tick-button__inner">
          <button disabled={loading} type="button" onClick={toggleCorrectAnswer}>
            <img src={`/static/icons/correct-answer-tick-${markedCorrect ? 'active' : 'inactive'}.svg`} alt="Mark correct" />
          </button>
          <div className="tick-button__tooltip">
            {markedCorrect ? 'Unmark correct' : 'Mark correct'}
          </div>
        </div>
      </div>
    );
  }
}

TickButton.propTypes = {

};

export default TickButton;